import Vue from 'vue'
import './vant/index'
import page from './page/index'
import tabbar from './page/tabbar'
import loadmore from './loadmore/index'
import noData from './no-data/index'
Vue.component('Loadmore', loadmore)
Vue.component('Page', page)
Vue.component('NoData', noData)



// WEBPACK FOOTER //
// ./src/components/index.js